import { render, staticRenderFns } from "./CenterViewEventTicketIssue_Ap.vue?vue&type=template&id=3b1fdcb5&scoped=true"
import script from "./CenterViewEventTicketIssue_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventTicketIssue_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventTicketIssue_Ap.vue?vue&type=style&index=0&id=3b1fdcb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fdcb5",
  null
  
)

export default component.exports